/* eslint-disable max-len */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'interfaces';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state['feature/session/chat'] || initialState;

export const selectLoader = createSelector([selectDomain], (ChatState) => ChatState.loading);
export const selectConversationLoader = createSelector([selectDomain], (ChatState) => ChatState.coversationLoading);
export const selectUploading = createSelector([selectDomain], (ChatState) => ChatState.uplaoding);
export const selectFilters = createSelector([selectDomain], (ChatState) => ChatState.filters);

export const selectConversations = createSelector([selectDomain], (ChatState) => ChatState.conversations);
export const selectConversationId = createSelector([selectDomain], (ChatState) => ChatState.coversationId);
export const selectSingleConversation = createSelector([selectDomain], (ChatState) => ChatState.conversation);
export const selectUserSession = createSelector([selectDomain], (ChatState) => ChatState.conversation.userSession);
